import React from 'react';
import {Route , Link} from 'react-router-dom';
import { CurrencySelector } from '../../_components';
import { ExchangePage } from '../ExchangePage';
import { currencyServices , transactionService , userService } from '../../_services'
import { currencyTypeConstants } from '../../_constants'
import { connect } from 'react-redux';
import { CompanyInfo } from './CompanyInfo';
import { utils} from '../../_helpers';
import { DepositForm } from './DepositForm'; 
import { DepositHWGCashForm} from './DepositHWGCashForm';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';
import qs from 'qs';

class DepositPage extends React.Component{
    
    constructor(props){
        super(props);

        this.state = {
            currencies : [] , 
            currency : '' , 
            amount : '', 
            filename : 'Proof of transaction', 
            blockChainTxId : '' , 
            file : null , 
            list : [] ,
            pages : 0 , 
            list_loading : true  , 
            settings : {} , 
            currencyType : '' ,
            disableSubmit : false , 
            image : '/images/no_uploaded.png'  , 
            isHWGCash : false 
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleCurrencyDropdown = this.handleCurrencyDropdown.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUploadFile = this.handleUploadFile.bind(this);
        this.onFetchData = this.onFetchData.bind(this);
    }

    componentDidMount(){
        //get type hwgcash
        const parsed = qs.parse(this.props.location.search.slice(1));

        if(parsed.type === 'hwgcash'){
            this.setState({
                isHWGCash : true
            })
        }
        
        currencyServices.getDepositEnabledCurrencies()
        .then(response => {
            
            //filter if hwgcash
            if(parsed.type === 'hwgcash' ){
                response = response.filter(curr => curr.id === 'HWGCash');

                this.setState({
                    
                    currency : 'HWGCash' , 
                    currencyType : currencyTypeConstants.CURRENCYTYPE_CASH
                })
            }

             if(response){
                 this.setState({
                     currencies : response , 
                 })
             }
        })
        
        transactionService.getCompanySettings()
        .then(response => {
 
             if(response){
                 this.setState({
                    settings : response
                 })
             }
        })

    }
    
    onFetchData(state , instance){
        const {  authentication } = this.props;

        state.page += 1;    //fix react table state started from one 
        
        transactionService.getMemberDepositList(state.page , state.pageSize , authentication.user.id)
        .then(response => {
            if(response){
                //update state with list 
                this.setState({
                    list : response.list , 
                    pages : response.pages , 
                    list_loading : false
                })
            }
        })
        
    }

    handleCurrencyDropdown(event){
        this.setState ({
            currency : event.target.value , 
            currencyType : event.target.selectedOptions[0].getAttribute('data-type') , 
            isHWGCash : event.target.value === "HWGCash" ? true : false
        })
    }
    
    handleChange(event){
        this.setState ({
            [event.target.name] : event.target.value  //update state of corresponding input name 
        })
    }

    handleSubmit(event){
        event.preventDefault();
        
        const {blockChainTxId , currency , amount , file , currencyType , isHWGCash } = this.state; 
        const { authentication } = this.props;

        if(currencyType === currencyTypeConstants.CURRENCYTYPE_CASH){
            //make sure file is not empty for cash transfer 
            if(!file){
                
                Alert.error(`Please upload proof of transaction slip to proceed`, {
                    position: 'bottom-right' , 
                    effect : 'flip'
                });

                return false;
            }
        }
        
        let formBody = {
            blockChainTxId : this.state.blockChainTxId , 
            currency : currency , 
            amount : amount , 
            memberId : authentication.user.id
        }; 

        this.setState({
            disableSubmit : true
        });

        transactionService.createMemberDeposit(formBody , file);
    }

    handleUploadFile (event){
        let file = event.target.files[0];

        if(file){
            this.setState ({
                filename : file.name ,
                file : file 
            });

            //display image 
            let reader = new FileReader();

            reader.onload = (e) => {
                this.setState({image: e.target.result});
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    render(){

        const {loading , authentication} = this.props;
        const { currencies , amount , filename , blockChainTxId , isHWGCash , memberBanks ,   
                list , pages , list_loading , page , settings , currencyType , image , file
        } = this.state;

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ; 
        let currency = this.state.currency;

        if(isHWGCash){
            currency = 'HWGCash';
        }

        //define table columns 
        const columns = [
            {
                Header: 'Currency',
                accessor: 'currency'  
            }, 
            {
                Header: 'Qty / Amount',
                accessor: 'amount'  
            }, 
            {
                Header: 'Order Date',
                accessor: 'createdstr'  
            }, 
            {
                Header: 'Status',
                accessor: 'status' , 
                Cell: row => (
                    <span className={`tag is-${row.value}`}>
                       {row.value}
                    </span>
                )  
            }, 
        ]

        return (
            <section className="section m-t-xs m-b-lg">
                <div className="container">
                    <div className="columns">
                        <div className="column is-6">
                        {
                            isHWGCash ? (
                                <DepositHWGCashForm authentication={authentication}  handleCurrencyDropdown={this.handleCurrencyDropdown} 
                                handleChange={this.handleChange} handleUploadFile={this.handleUploadFile}
                                currencies={currencies} currency={currency} blockChainTxId={blockChainTxId}
                                currencyType={currencyType} settings={settings} file={file}
                                amount={amount} filename={filename} image={image} disableSubmit={disableSubmit}/>
                            )
                            :(
                                <DepositForm authentication={authentication}  handleCurrencyDropdown={this.handleCurrencyDropdown} 
                                handleChange={this.handleChange} handleUploadFile={this.handleUploadFile}
                                currencies={currencies} currency={currency} blockChainTxId={blockChainTxId}
                                currencyType={currencyType} settings={settings} file={file}
                                amount={amount} filename={filename} image={image} disableSubmit={disableSubmit}/>
                            )
                        }

                        </div>

                        <div className="column is-6">
                            <h4>Deposit Orders</h4>
                            
                            <div className=" m-t-md">
                                <ReactTable
                                    manual
                                    data={list}
                                    pages={pages}
                                    loading={list_loading}
                                    columns={columns}
                                    defaultPageSize = {5} 
                                    onFetchData = {this.onFetchData}
                                    className="-striped -highlight"
                                    NoDataComponent = { ()=> { return []} }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    const { authentication  } = state;

    return {
        authentication
    };
}

const connectedPage = connect(mapStateToProps)(DepositPage);
export { connectedPage as DepositPage }; 



// WEBPACK FOOTER //
// ./src/Views/DepositPage/DepositPage.jsx